module.exports = __webpack_public_path__ + "static/media/facebook-bk.0484d1ab.png";